import { formatUrlId, parseUrlId } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import { BrowseLoadView } from '@/features/matching/browse-load-view'

export const Route = createFileRoute('/_authenticated/matching/browse/$load_id')({
  params: {
    parse: ({ load_id }) => ({ load_id: parseUrlId(load_id) }),
    stringify: ({ load_id }) => ({ load_id: formatUrlId('LD', load_id) }),
  },
  component: BrowseLoadView,
})
